import{a as r}from"./chunk-PXDN3KFO.js";import o from"js-cookie";var i=e=>o.get(e),g=(e,t,n)=>o.set(e,t,r({},n)),k=(e,t)=>o.remove(e,r({},t));export{i as a,g as b,k as c};
